import { isPlatformBrowser } from '@angular/common'
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'

import { ButtonComponent } from 'app/_shared/components/button/button.component'
import { AuthService } from 'app/_shared/services/auth.service'
import { ToastService } from 'app/_shared/services/toast.service'
import { UserStore } from 'app/store/user.store'

@Component({
  selector: 'app-email-verification',
  imports: [ButtonComponent, TranslatePipe],
  templateUrl: './email-verification.component.html',
  styleUrl: './email-verification.component.scss'
})
export class EmailVerificationComponent implements OnInit {
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute)
  private toastService = inject(ToastService)
  private authService: AuthService = inject(AuthService)
  private router = inject(Router)
  private userStore = inject(UserStore)
  readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID))

  ngOnInit(): void {
    // Email verification is a one-time side effect. Running it during SSR
    // consumes the token before the hydrated browser application can update
    // its UserStore and local storage.
    if (!this.isBrowser) {
      return
    }

    this.activatedRoute.queryParams.subscribe(params => {
      const token = params['token']
      if (typeof token === 'string' && token) {
        this.checkTokenValidity(token)
      } else {
        const returnUrl = params['returnUrl']
        if (this.userStore.isVerified()) {
          this.router.navigateByUrl(returnUrl ?? '/')
        }
      }
    })
  }

  private checkTokenValidity(token: string): void {
    this.authService.verifyEmail(token).subscribe({
      next: res => {
        const data = res.data
        this.userStore.storeUser(data.user, data.access_token)
        const redirect = localStorage.getItem('returnUrl') ?? '/'
        localStorage.removeItem('returnUrl')
        this.router.navigateByUrl(redirect)
      },
      error: err => {
        if (err.status === 404) {
          this.toastService.error('Invalid token. Please try again.')
          return
        }
      }
    })
  }

  resendEmail() {
    this.authService.resendVerificationEmail().subscribe({
      next: () => {
        this.toastService.success('Email verification sent again!')
      },
      error: err => {
        this.toastService.error(err.error.message)
      }
    })
  }
}
